import { createReducer } from '@reduxjs/toolkit';
import { loadPaymentMethods } from '../actions/loadPaymentMethods';
import { checkApCanMakePayments } from '../actions/checkApCanMakePayments';
import { checkApHighestSupportedVersion } from '../actions/checkApHighestSupportedVersion';
import { loadPayPalScript } from '../actions/loadPayPalScript';
import { loadApplePayScript } from '../actions/loadApplePayScript';
import { addAsyncStatusCases } from '../utils/redux/addAsyncStatusCases';

export type AsyncStatus = 'idle' | 'pending' | 'fulfilled' | 'rejected';

export interface RequestState {
  loadPaymentMethods: AsyncStatus;
  loadPayPalScript: AsyncStatus;
  loadApplePayScript: AsyncStatus;
  canMakePayments: AsyncStatus;
  highestSupportedApplePayVersion: AsyncStatus;
}

const initialState: RequestState = {
  loadPaymentMethods: 'idle',
  loadPayPalScript: 'idle',
  loadApplePayScript: 'idle',
  canMakePayments: 'idle',
  highestSupportedApplePayVersion: 'idle',
};

export const requestsStateReducer = createReducer(initialState, (builder) => {
  addAsyncStatusCases(builder, loadPaymentMethods, (state, status) => {
    state.loadPaymentMethods = status;
  });
  addAsyncStatusCases(builder, loadPayPalScript, (state, status) => {
    state.loadPayPalScript = status;
  });
  addAsyncStatusCases(builder, loadApplePayScript, (state, status) => {
    state.loadApplePayScript = status;
  });
  addAsyncStatusCases(builder, checkApCanMakePayments, (state, status) => {
    state.canMakePayments = status;
  });
  addAsyncStatusCases(builder, checkApHighestSupportedVersion, (state, status) => {
    state.highestSupportedApplePayVersion = status;
  });
});
